import Vue from 'vue'
import VueRouter from 'vue-router'
import appContent from '@/components/content'

import main from '@/components/main'
import agacdetay from '@/components/detay'
import siparis from '@/components/siparis'
import deneme from '@/components/denetim/agac'
import cuzdan from '@/components/cuzdan'
import havuz from '@/components/havuz'
import urun from '@/components/urunler'
import sepet from '@/components/sepet'
import bayi from '@/components/bayi'
import pays from '@/components/pays'

import agac from '@/components/agac'


import kampanya from '@/components/kampanyali'
import hesap from '@/components/hesap'

import LoginPage from '@/components/LoginPage'
Vue.use(VueRouter)

  const routes = [
    {path: '/login', component: LoginPage},
    {
      path:'/',
      component:appContent,
      redirect:'/',
      children:[
    { 
      path: "/",
      component: main ,
      Name : "/",
      meta: {
        title: 'Queries'
      }      
    },
    { 
      path: "/deneme",
      component: deneme ,
      Name : "deneme"
    },    
    { 
      path: "/yeni-bayi",
      component: bayi ,
      Name : "Yeni Bayi"
    },
    { 
      path: '/detay/:kod/:ad',
      component:agacdetay ,
      Name : "Organisazyon detay"
    },
    { 
      path: '/siparis',
      component:siparis ,
      Name : "Sipariş"
    },    
    {  path: "/havuz",component: havuz},
    { 
      path: "/cuzdan",
      component: cuzdan ,
      Name : "Cüzdan"
    },

    { 
      path: "/sepet",
      component: sepet ,
      Name : "Sepetiniz"
    },
    { 
      path: "/pays",
      component: pays ,
      Name : "Ödeme Bilgileri"
    },
    { 
      path: "/urunler",
      component: urun ,
      Name : "Ürünler"
    },
    { 
      path: "/hesap",
      component: hesap ,
      Name : "Hesabım"
    },
    { 
      path: "/agac",
      component: agac ,
      Name : "Organisazyon"
    } 
  ]
}
];
  export const router = new VueRouter({
   //mode: "history",
    routes
  });
  router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('tfx');
    if (authRequired && !loggedIn) {
  
      return next({ 
        path: '/login', 
        query: { returnUrl: to.path } 
      });
    }
  
    next();
  })



// WEBPACK FOOTER //
// ./src/router/index.js